import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e57dc90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo.png",
  alt: "КлеверFarmer",
  height: "38"
}, null, -1))
const _hoisted_3 = {
  style: {"color":"#ebf1e5"},
  class: "q-mr-xl"
}
const _hoisted_4 = {
  key: 0,
  style: {"color":"orangered","text-shadow":"1px 1px 1px #000"}
}
const _hoisted_5 = {
  class: "q-gutter-md",
  style: {"width":"300px"}
}
const _hoisted_6 = { class: "q-gutter-md wrapper-search" }
const _hoisted_7 = {
  key: 0,
  class: "wrapper-tabs"
}
const _hoisted_8 = { class: "slotItem map-item full-width full-height relative-position" }
const _hoisted_9 = {
  key: 0,
  class: "slotItem navPanel full-height"
}
const _hoisted_10 = {
  key: 1,
  class: "slotItem expandedPanel"
}

import { computed, ref, watch } from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { useRoute } from 'vue-router';
import Search from '@/components/Search/Search.vue';
import LeftDrawerNavigation from '@/components/LeftDrawerNavigation/LeftDrawerNavigation.vue';
import usePanel from '@/hooks/usePanel';
import MobileLeftDrawerNavigation from '@/components/LeftDrawerNavigation/MobileLeftDrawerNavigation.vue';
import OrganizationAutocomplete from '@/components/OrganizationAutocomplete/OrganizationAutocomplete.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'panel',
  setup(__props) {

const isStaging = !!process.env.VUE_APP_STAGING;

const $q = useQuasar();
const { t } = useI18n();

const leftDrawerOpen = ref(!($q.screen.sm || $q.screen.xs));

const { isNavPanel, isExpandedPanel } = usePanel();

const isShowDrawer = computed(() => $q.screen.sm || $q.screen.xs);

const toggleLeftDrawer = () => {
  leftDrawerOpen.value = !leftDrawerOpen.value;
};

const $route = useRoute();

const activeTab = ref('map');
const tabsItems = ref([]);

watch($route, () => {
  const arrayItems = [];
  if (isNavPanel.value) {
    const newItem = { id: 'navPanel', title: $route.meta.navPanelTitle, key: Math.random() };
    arrayItems.push(newItem);
    activeTab.value = newItem.id;
  }

  if (isExpandedPanel.value) {
    const newItem = { id: 'expandedPanel', title: $route.meta.expandedPanelTitle, key: Math.random() };
    arrayItems.push(newItem);
    activeTab.value = newItem.id;
  }
  arrayItems.push({ id: 'map', title: t('map.title'), key: Math.random() });
  tabsItems.value = arrayItems;
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "lHh lpR lff" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, {
        reveal: "",
        elevated: "",
        class: "bg-primary text-white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                dense: "",
                flat: "",
                round: "",
                icon: "mdi-menu",
                onClick: toggleLeftDrawer
              }),
              ((_unref($q).screen.sm || _unref($q).screen.xs) && _unref(isNavPanel))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_q_tabs, {
                      modelValue: activeTab.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                      align: "left",
                      "inline-label": "",
                      "outside-arrows": "",
                      "mobile-arrows": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsItems.value, ({title, key, id}) => {
                          return (_openBlock(), _createBlock(_component_q_tab, {
                            key: key,
                            name: id,
                            label: title
                          }, null, 8, ["name", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_toolbar_title, { class: "flex no-wrap sm-hide xs-hide" }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createElementVNode("span", _hoisted_3, [
                    _createTextVNode(" 3.0 "),
                    isStaging
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "staging"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(OrganizationAutocomplete)
                  ]),
                  _createVNode(_component_q_space),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(Search)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!isShowDrawer.value)
        ? (_openBlock(), _createBlock(LeftDrawerNavigation, {
            key: 0,
            "left-drawer-open": leftDrawerOpen.value
          }, null, 8, ["left-drawer-open"]))
        : (_openBlock(), _createBlock(MobileLeftDrawerNavigation, {
            key: 1,
            "left-drawer-open": leftDrawerOpen.value,
            "onUpdate:leftDrawerOpen": _cache[1] || (_cache[1] = ($event: any) => ((leftDrawerOpen).value = $event))
          }, null, 8, ["left-drawer-open"])),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_page, null, {
            default: _withCtx(() => [
              ((_unref($q).screen.sm || _unref($q).screen.xs))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    (_unref(isNavPanel))
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_router_view, { name: "navPanel" })
                        ], 512)), [
                          [_vShow, activeTab.value === 'navPanel']
                        ])
                      : _createCommentVNode("", true),
                    (_unref(isExpandedPanel))
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_router_view, { name: "expandedPanel" })
                        ], 512)), [
                          [_vShow, activeTab.value === 'expandedPanel']
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!(_unref($q).screen.sm || _unref($q).screen.xs))
                ? _renderSlot(_ctx.$slots, "default", { key: 1 })
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})